import { Box, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

interface PopularAirlinesProps {
    title: string
    summary: string
}

const PopularAirlines: React.FC<PopularAirlinesProps> = ({ title, summary }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 1.5 }}
            >
                {title}
            </Typography>
            <RichText html={summary} variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }} />
        </Box>
    )
}

export default PopularAirlines
export type { PopularAirlinesProps }
